<template>
	<main class="app-main">
		<div class="content-wrap">
			<section class="content-section">
				<header class="section-header">
					<h2 class="section-title">{{ $t('routes.properties.title') }}</h2>
				</header>
				<article>
					<actions-panel>
						<button class="button style-3" @click.stop.prevnet="$store.commit('SHOW_PROPERTY_CREATE_FORM')">
							<span class="inner">{{ $t('property.add_property') }}</span>
						</button>
						<router-link :to="$t('routes.home.path')" class="button style-1">
							<span class="inner">{{ $t('general.back') }}</span>
						</router-link>
					</actions-panel>
					<chart-finance-panels-group :charts-data="chartsData"
					                            :finance-panels-data="financePanelsData"
					                            :title="$t('property.property_list')"
					                            v-if="financePanelsData.length"/>
					<p v-else>{{ $t('property.no_property') }}</p>
				</article>
			</section>
		</div>
	</main>
</template>

<script>


import ActionsPanel from "@/components/panels/ActionsPanel";
import ChartFinancePanelsGroup from "@/components/containers/ChartFinancePanelsGroup";
import investmentsMixin from "@/mixins/investmentsMixin";

export default {
	name: "Properties",
	mixins: [investmentsMixin],
	components: {
		ActionsPanel,
		ChartFinancePanelsGroup
	},
	computed: {
		financePanelsData() {
			let data = [];
			this.$store.state.views.properties.forEach((item) => {
				let icon = this.getIcon(item.type);
				data.push({
					id: item.id,
					icon,
					name: item.name,
					value: item.value,
					finance_type: 'property',
					property_type: item.property_type,
					investment_account_type: item.investment_account_type,
				});
			});

			return data;
		},
		chartsData() {
			let data = [
				this.getPortfoliosChartOptions(),
			];

			let types = {
				car: 0,
				real_estate: 0,
				land: 0,
				valuable: 0,
				intangible_asset: 0,
				investment: 0,
				other: 0,
			};

			this.$store.state.views.properties.forEach((item) => {
				let value = parseFloat(item.value);
				types[item.type] += value;
			});

			let labels = [];
			let series = [];

			Object.entries(types).forEach(([key, value]) => {
				if (value > 0) {
					labels.push(this.$t(`property.${key}_graph`));
					series.push(Math.round(value * 100) / 100);
				}
			});

			data[0].chartOptions.labels = labels;
			data[0].series = series;

			return data;
		},
	},
	methods: {
		getIcon(type) {
			let icon;
			switch (type) {
				case 'car':
					icon = 'fa-car';
					break;
				case 'real_estate':
					icon = 'fa-house';
					break;
				case 'land':
					icon = 'fa-map';
					break;
				case 'valuable':
					icon = 'fa-gem';
					break;
				case 'intangible_asset':
					icon = 'fa-brain';
					break;
				case 'investment':
					icon = 'fa-chart-line-up';
					break;
				default:
					icon = 'fa-wallet';
					break;
			}

			return `<i class="fa-thin ${icon}"></i>`;
		}
	}
}
</script>

<style scoped lang="scss">

</style>